module.exports = __webpack_public_path__ + "images/DepositPopup5f2e323e601c7471e70229fd85ef45a9.png";